<template>
  <transition name="fly-in">
    <div v-if="isShow" class="service-error">
      <p class="service-error__message">
        We’ve detected that some of our services are down, so please try again. We apologise for any
        inconvenience caused.
      </p>
      <BaseButton
        class="service-error__close-btn"
        style-type="icon-only"
        data-test="close"
        aria-label="Close"
        @click="$emit('close')"
      >
        <img src="@/assets/icons/lightbox-cross.svg" alt="close" />
      </BaseButton>
      <p class="service-error__time">{{ dayjs().format('DD-MM-YYYY HH:mm:ss ZZ') }}</p>
    </div>
  </transition>
</template>

<script setup lang="ts">
  import dayjs from 'dayjs';
  import { useRouter } from 'vue-router';

  import BaseButton from '@/components/base/BaseButton.vue';

  const router = useRouter();

  router.beforeEach(() => {
    emit('close');
  });

  const emit = defineEmits<{
    (e: 'close'): void
  }>();

  defineProps<{ isShow: boolean }>();
</script>

<style scoped lang="scss">
  .service-error {
    position: fixed;
    right: 0;
    bottom: 20px;
    left: 0;
    z-index: 10;
    display: grid;
    grid-auto-flow: column;
    align-items: flex-start;
    width: 100%;
    max-width: 600px;
    padding: 24px;
    margin: 0 auto;
    background: $red-2;
    border-radius: 2px;
    box-shadow: 0 20px 60px $black-rgb-25;

    &__message {
      grid-column: 1 / 2;
      color: $white;
    }

    &__close-btn {
      grid-column: 2 / 3;
    }

    &__time {
      grid-column: 1 / 3;
      margin-bottom: 0;
      color: $white;
    }
  }

  .fly-in-enter-active,
  .fly-in-leave-active {
    transition: all 0.5s ease;
  }

  .fly-in-enter-from,
  .fly-in-leave-to {
    opacity: 0;
    transform: translateY(-10px);
  }

  .fly-in-enter-to {
    opacity: 1;
    transform: translateY(0);
  }
</style>
